import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function PageBreadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={c.label} className="flex items-center gap-1.5">
            {last || !c.to ? (
              <span className="text-foreground-700">{c.label}</span>
            ) : (
              <Link to={c.to} className="hover:text-primary-600">
                {c.label}
              </Link>
            )}
            {!last && <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />}
          </span>
        );
      })}
    </nav>
  );
}